// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-block{padding:0 20px 20px 0}.link-block a{color:#000;text-transform:capitalize;padding:0 20px;font-weight:500}.link-block a.active{color:#2EA0DC}.link-block span.active{display:block;height:3px;border-radius:10px;background:#2EA0DC;top:3px;position:relative}@media (max-width: 767px){.link-block{padding:0 0 20px 0;width:50%;text-align:center}}\n", ""]);
// Exports
module.exports = exports;
